import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { IQuantity } from "libraries/hotel/models/quote";

@Component({
    selector: 'traveller-quantity',
    template: `
        <div *ngIf="quantity?.adult" class="quantity">
            {{quantity.adult}} ADT
        </div>
        <div *ngIf="quantity?.child" class="quantity">
            {{quantity.child}} CHD
        </div>
        <div *ngIf="quantity?.infant" class="quantity">
            {{quantity.infant}} INF
        </div>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
    styles: [`
        .quantity {
            font-weight: bold
        }
    `]
})

export class TravellerQuantityComponent {

    @Input()
    public quantity: IQuantity;

}